import { RxIcon } from '@/components/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useNewPrescriptionCount } from '@/lib/use-new-prescriptions';

/**
 * "2 new prescriptions" in the header, and nothing at all when there are none.
 *
 * The prescription twin of `NewOrdersPill`, for the same reason: an unread
 * prescription is a customer who cannot order until somebody here reads it.
 * A button, not a label - the thing announcing it is the way to go and deal
 * with it - and absent rather than "0", so the row only ever speaks when it
 * has something to say.
 */
export function NewPrescriptionsPill() {
  const navigate = useNavigate();
  const count = useNewPrescriptionCount();

  if (!count) return null;

  return (
    <Button
      danger
      type="primary"
      icon={<RxIcon />}
      onClick={() => navigate('/prescriptions')}
      // Announced when the number changes, without interrupting.
      aria-live="polite"
    >
      <span data-numeric>
        {count} new {count === 1 ? 'prescription' : 'prescriptions'}
      </span>
    </Button>
  );
}
